import React from "react";
import FetchApi from "../../../../customhooks/functionFetchApi"

const FetchApis =new FetchApi();

export function getcolor8(tecId, NewtecId){
        FetchApis.FethcGet(`/color/getInk8colorbytecbid/${tecId}`).then(res=>{
            if(res){
                var dataall=res.data.data;
                for (let index = 0; index < dataall.length; index++) {
                    const colorlist = dataall[index];
                        createcolor8(colorlist,NewtecId);
                }   
            }
        })
}

function createcolor8(colorlist,NewtecId){
     var objectdata={
         tecbid:NewtecId,
            colorshqde_unit1:colorlist.colorshqde_unit1,
            Idcolor_unit1:colorlist.Idcolor_unit1,
            fmcode_unit1:colorlist.fmcode_unit1,
            thicknes_unit1:colorlist.thicknes_unit1,
            density_unit1:colorlist.density_unit1,
            temp_unit1:colorlist.temp_unit1,
            uvlamp_unit1:colorlist.uvlamp_unit1,
            speed_unit1:colorlist.speed_unit1
    }

    FetchApis.FethcPost(`/color/createInk8color`,objectdata).then(res=>{

    })
}